import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Pagination from "react-bootstrap/Pagination";
import "./TablePagination.scss";

const TablePagination = ({
  selectedPage,
  totalResults,
  resultsPerPage = 10,
  setSelectedPage,
}) => {
  const totalPages = Math.ceil(totalResults / resultsPerPage);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== selectedPage) {
      setSelectedPage(page);
    }
  };

  // Generate pagination numbers dynamically
  const getPaginationItems = () => {
    const items = [];

    const showPages = 3; // how many pages before and after current
    const start = Math.max(1, selectedPage - showPages);
    const end = Math.min(totalPages, selectedPage + showPages);

    if (start > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageClick(1)}>
          1
        </Pagination.Item>
      );
      if (start > 2) items.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }

    for (let number = start; number <= end; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === selectedPage}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1)
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  const startItem = totalResults?(selectedPage - 1) * resultsPerPage + 1:0;
  const endItem = Math.min(selectedPage * resultsPerPage, totalResults);

  return (
    <div className="table-pagination mt-4 mt-lg-0">
      <Row className="align-items-center gy-3 gy-lg-0">
        <Col lg="6">
          <p className="fs-6 fw-500 mb-0 px-3 text-center text-lg-start">
            Showing {startItem || 0} to {endItem || 0} of {totalResults || 0} results
          </p>
        </Col>
        <Col lg="6">
          <Pagination className="flex-wrap justify-content-center justify-content-lg-end mb-0">
            <Pagination.Prev
              onClick={() => handlePageClick(selectedPage - 1)}
              disabled={selectedPage === 1}
            >
              <img
                src="/images/caret-left.svg"
                width={20}
                height={20}
                alt="Arrow Left"
              />
            </Pagination.Prev>

            {getPaginationItems()}

            <Pagination.Next
              onClick={() => handlePageClick(selectedPage + 1)}
              disabled={selectedPage === totalPages}
            >
              <img
                src="/images/caret-right.svg"
                width={20}
                height={20}
                alt="Arrow Right"
              />
            </Pagination.Next>
          </Pagination>
        </Col>
      </Row>
    </div>
  );
};

export default TablePagination;
